import { NgClass } from "@angular/common";
import { Component, OnChanges, Input } from "@angular/core";
import { HighchartsChartComponent } from "highcharts-angular";
import Highcharts from "highcharts/esm/highcharts";

@Component({
	selector: "app-dvs-chart",
	templateUrl: "./dvs-chart.component.html",
	styleUrls: ["./dvs-chart.component.scss"],
	imports: [HighchartsChartComponent, NgClass],
})
export class DvsChartComponent implements OnChanges {
	@Input()
	options: Highcharts.Options;
	@Input()
	height: string;
	@Input()
	error: string;
	@Input()
	timezone: number;
	@Input()
	short: boolean;
	@Input()
	loading: string;

	private chartInstance: Highcharts.Chart;
	private lastSelected: Highcharts.Point;

	public Highcharts = Highcharts;
	public chartLoaded = false;

	public get chart(): Highcharts.Chart {
		return this.chartInstance;
	}

	ngOnChanges() {
		if (!this.options) {
			this.chartLoaded = false;
			this.chartInstance = undefined;
		}
		if (!this.height) {
			this.height = "300px";
		}
		if (!this.timezone) {
			this.timezone = 0;
		}
		if (!this.loading) {
			this.loading = "Loading...";
		}
		Highcharts.setOptions({
			time: {
				timezoneOffset: -this.timezone * 60,
			},
		});

	}
	onLoad(chartInstance) {
		this.chartInstance = chartInstance;
		this.chartLoaded = true;
	}

	public UpdatePlotLine() {
		if (this.chartInstance && this.chartInstance.xAxis && this.chartInstance.xAxis.length) {
			(this.chartInstance.xAxis[0] as any).plotLinesAndBands[0].render();
		}
	}

	/** Select a point from a given series, where point[key] matches value */
	public SelectPoint(seriesIndex?: number, pointKey?: string, pointValue?: number) {
		if (this.lastSelected && this.lastSelected.setState) {
			this.lastSelected.setState();
			this.chartInstance.tooltip.hide();
			this.lastSelected = undefined;
		}
		if (seriesIndex !== undefined && pointKey !== undefined) {
			const series = this.chartInstance.series[seriesIndex];
			const point = series.data.find(item => item[pointKey] === pointValue);
			point.setState("hover");
			this.chartInstance.tooltip.refresh(point);
			this.lastSelected = point;
		}
	}

	public SetSeriesData(seriesIndex: number, data: any[]) {
		this.SelectPoint();
		this.chartInstance.series[seriesIndex].setData(data);
	}
}
